/* sf-resumen
 * Arma el bloque "Tu kit" leyendo lo que ya hay en la pagina. No guarda estado propio:
 * si alguien cambia algo por otro camino, el resumen se rehace igual.
 */
(function () {
  'use strict';

  function seccion(el) {
    return el.closest('.shopify-section') || document;
  }

  function plata(n, moneda) {
    return '$' + Number(n || 0).toLocaleString('es-UY') + ',00 ' + (moneda || '');
  }

  /** Opciones nativas de Shopify (Modelo, etc). Devuelve [{et, val}] */
  function nativas(raiz) {
    var out = [];
    var vs = raiz.querySelector('variant-selects');
    if (!vs) return out;

    vs.querySelectorAll('select').forEach(function (sel) {
      var et = (sel.closest('.product-form__input') || {}).querySelector
        ? (sel.closest('.product-form__input').querySelector('.form__label') || {}).textContent
        : null;
      if (sel.value) out.push({ et: (et || 'Opción').trim().replace(/:$/, ''), val: sel.value });
    });

    var grupos = {};
    vs.querySelectorAll('input[type=radio]').forEach(function (i) {
      (grupos[i.name] = grupos[i.name] || []).push(i);
    });
    Object.keys(grupos).forEach(function (n) {
      var marcado = grupos[n].filter(function (i) { return i.checked; })[0];
      if (!marcado) return;
      var cont = marcado.closest('fieldset') || marcado.closest('.product-form__input');
      var et = cont ? (cont.querySelector('legend, .form__label') || {}).textContent : null;
      out.push({ et: (et || 'Opción').trim().replace(/:$/, ''), val: marcado.value });
    });
    return out;
  }

  /** Un valor que es un enlace no se muestra en el resumen: al comprador no le dice
   *  nada y parece un error. Cubre "//cdn...", "https://..." y "http://...". */
  function esURL(v) {
    return /^\s*(https?:)?\/\//i.test(String(v));
  }

  /** El precio que vale es el de la VARIANTE seleccionada: es el que Shopify
   *  muestra arriba y el que cobra en el carrito, asi que no se puede
   *  desincronizar. El dataset.precio del selector solo se refresca en el modo
   *  personalizado; al volver a Simil se quedaba con el numero de la opcion
   *  anterior, y el total de "Tu kit" no coincidia con el precio de arriba.
   *  Lo reporto el cliente el 2026-09-16 (veia $1.200 arriba y $1.300 de total).
   *  Shopify deja la variante elegida en este script y la reescribe en cada
   *  cambio, asi que siempre esta al dia. El precio viene en centavos. */
  function precioDeLaVariante() {
    var js = document.querySelector('variant-selects script[data-selected-variant]');
    if (!js) return null;
    try {
      var v = JSON.parse(js.textContent);
      if (v && v.price != null && isFinite(+v.price)) return Math.round(+v.price) / 100;
    } catch (e) {}
    return null;
  }

  /** Lo que eligió en el selector de colores, leído de sus propios campos ocultos.
   *  Son los mismos que viajan al carrito, así que el resumen no puede decir una cosa
   *  y el pedido llegar con otra. */
  function delSelector(raiz) {
    var sel = raiz.querySelector('sticker-color-selector');
    if (!sel) return { filas: [], precio: null };
    var filas = [];
    sel.querySelectorAll('input[type=hidden][name^="properties["]').forEach(function (i) {
      var et = (i.getAttribute('name') || '').replace(/^properties\[/, '').replace(/\]$/, '');
      if (!i.value || et.charAt(0) === '_') return;
      // "Foto de la combinacion" lleva la URL del archivo. Es a proposito: produccion
      // la abre desde el pedido como guia de armado. Pero al comprador una URL pelada
      // en "Tu kit" le queda como si algo estuviera roto, asi que se esconde de la
      // VISTA y se sigue mandando igual al pedido.
      // Ojo: NO alcanza con renombrarla con "_" adelante. Eso la esconderia tambien
      // del panel del admin, que es justo donde produccion la necesita.
      if (esURL(i.value)) return;
      filas.push({ et: et, val: i.value });
    });
    var p = precioDeLaVariante();
    if (p === null) {
      var d = sel.dataset.precio;                 // respaldo por si no hay variante a mano
      p = (d === undefined || d === '') ? null : Number(d);
    }
    return { filas: filas, precio: p };
  }

  function extras(raiz) {
    var out = [];
    raiz.querySelectorAll('.sf-extra__sw').forEach(function (sw) {
      if (!sw.checked || sw.disabled) return;
      var tarjeta = sw.closest('.sf-extra');
      if (!tarjeta) return;
      var nombre = (tarjeta.querySelector('.sf-extra__nombre') || {}).textContent || 'Extra';
      var txt = (tarjeta.querySelector('.sf-extra__precio') || {}).textContent || '';
      // El monto sale de data-precio (centavos, puesto por Liquid), NO del texto.
      // Parsear "$250" y asumir centavos daba $2,50 y el total salia mal por 100.
      // El precio del kit viene en pesos enteros, asi que los centavos se dividen por 100.
      var cent = Number(tarjeta.getAttribute('data-precio'));
      var monto = isFinite(cent) && cent > 0 ? Math.round(cent / 100) : 0;
      out.push({ et: nombre.trim(), val: txt.trim(), monto: monto });
    });
    return out;
  }

  /* ===== Que se MUESTRA y que se MANDA ==========================================
   * Cliente 2026-09-17: "eliminar info que es mas que nada para produccion, dejarlo mas
   * limpio para el cliente", con una captura donde se repetia todo, y otra de Simil Original
   * marcada con un tilde porque ahi ya estaba simple.
   *
   * Todo lo de aca abajo es de VISTA. Nada toca los campos ocultos, asi que el pedido sigue
   * llegando completo a produccion, que es donde los codigos y la combinacion si hacen falta.
   * Mismo criterio que `esURL`, que esconde la URL de la foto desde el 2026-09-16.
   *
   * Lo que se repetia, medido en su captura del XR 150:
   *   Color de la moto: Especiales 2 + Especiales 2   <- la variante nativa, o sea el escalon
   *                                                      de precio, no un color
   *   Color 1: C31 - Holographic Burgundy (Especiales 2)   <- la categoria otra vez
   *   Combinacion: C31 + C33                                <- Color 1 + Color 2 otra vez
   *   Detalle de la combinacion: ... (C33 - Holographic Silver)  <- y otra vez
   */

  // Nombres que son para produccion y no le dicen nada al comprador. Se siguen mandando.
  var SOLO_PRODUCCION = ['Combinación', 'Detalle de la combinación'];

  function esDeProduccion(et) {
    return SOLO_PRODUCCION.indexOf(et) !== -1;
  }

  /* "C31 - Holographic Burgundy (Especiales 2)" -> "C31 - Holographic Burgundy".
   * La categoria es la grilla de precios; el comprador ya la eligio y verla repetida en cada
   * renglon es justo lo que el marco. Solo se saca cuando el parentesis va al FINAL, para no
   * comerse un nombre de color que tenga parentesis propios. */
  function sinCategoria(v) {
    return String(v).replace(/\s*\([^()]*\)\s*$/, '').trim();
  }

  /* Vinilo impreso: el valor es "CMYK 0/0/0/100 / HEX #111111". El comprador no lee eso.
   * Su boceto pide un circulito del color. Se saca el HEX y se devuelve para pintarlo;
   * si no hay HEX se deja el texto como esta. */
  function hexDe(v) {
    var m = /#([0-9a-f]{6}|[0-9a-f]{3})\b/i.exec(String(v));
    return m ? '#' + m[1] : null;
  }

  /* En Colores Personalizados la segunda opcion nativa NO es un color: es el escalon de
   * precio ("Especiales 2 + Especiales 2") o, en impreso, el color de moto que quedo de
   * Simil Original, que es el "me traslada el rojo con negro" que reporto. El selector ya
   * dice los colores de verdad, asi que sobra.
   * En Simil Original esa misma opcion SI es el color de la moto y se deja: esa es la
   * captura que el marco con el tilde. */
  function enPersonalizados(raiz) {
    var sel = raiz.querySelector('sticker-color-selector');
    if (!sel) return false;
    try { return sel.state && sel.state.option === 'custom'; } catch (e) { return false; }
  }

  function pintar(caja) {
    var raiz = seccion(caja);
    var lista = caja.querySelector('[data-lista]');
    var vacio = caja.querySelector('[data-vacio]');
    var totEl = caja.querySelector('[data-total]');
    var moneda = caja.getAttribute('data-moneda') || '';

    var sel = delSelector(raiz);
    var custom = enPersonalizados(raiz);

    /* De las opciones nativas se deja siempre la primera (Opción). Las de mas atras solo
     * valen en Simil Original; en Personalizados son el escalon de precio o un color que
     * quedo de la otra pestaña. */
    var nat = nativas(raiz);
    if (custom) nat = nat.slice(0, 1);

    /* "Opción" la dicen los dos, el desplegable nativo y el selector, con el mismo valor.
     * Se deja la NATIVA y se descarta la del selector, no al reves: asi el orden queda
     * Opción / Color de la moto / ... , que es como se ve en la captura de Simil Original
     * que el marco con el tilde. Quitando la nativa, "Color de la moto" se le adelantaba. */
    var enNat = {};
    nat.forEach(function (f) { enNat[f.et] = true; });
    var propias = sel.filas.filter(function (f) { return !enNat[f.et]; });

    var filas = nat.concat(propias).filter(function (f) { return !esDeProduccion(f.et); });
    var ex = extras(raiz);
    filas = filas.concat(ex.map(function (e) { return { et: e.et, val: e.val }; }));

    lista.querySelectorAll('.sf-resumen__fila').forEach(function (n) { n.remove(); });

    filas.forEach(function (f) {
      var fila = document.createElement('div');
      fila.className = 'sf-resumen__fila';
      var dt = document.createElement('dt');
      dt.textContent = f.et;
      var dd = document.createElement('dd');

      var hex = /^Color\b/.test(f.et) ? hexDe(f.val) : null;
      if (hex) {
        // Impreso: circulito del color en vez de "CMYK .. / HEX ..".
        var punto = document.createElement('span');
        punto.className = 'sf-resumen__punto';
        punto.style.background = hex;
        // El codigo queda en el title por si lo necesita a mano, y en el pedido entero.
        punto.title = f.val;
        dd.appendChild(punto);
      } else {
        dd.textContent = sinCategoria(f.val);
      }

      fila.appendChild(dt);
      fila.appendChild(dd);
      lista.appendChild(fila);
    });

    if (vacio) vacio.hidden = filas.length > 0;

    if (sel.precio === null) {
      // Sin precio del selector no se inventa un total. Un total equivocado es peor que
      // ninguno: el comprador lo lee como una promesa.
      totEl.textContent = '—';
      return;
    }
    var total = sel.precio;
    ex.forEach(function (e) { total += e.monto; });
    totEl.textContent = plata(total, moneda);
  }

  function arrancar() {
    document.querySelectorAll('[data-sf-resumen]').forEach(function (caja) {
      if (caja.dataset.listo === '1') return;
      caja.dataset.listo = '1';
      var raiz = seccion(caja);
      var repintar = function () { pintar(caja); };
      raiz.addEventListener('change', repintar);
      raiz.addEventListener('scs:precio', repintar);
      // El selector reescribe sus campos ocultos sin disparar `change`, asi que hace falta
      // mirar el arbol. Sin esto el resumen se queda con el color anterior.
      var mo = new MutationObserver(repintar);
      var sel = raiz.querySelector('sticker-color-selector');
      if (sel) mo.observe(sel, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'data-precio'] });
      repintar();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
